import { rdEquipamentosService } from '@/services/quotes/rd-equipamentos';
import type { RdProposal } from '@/services/quotes/rd-equipamentos/types';
import { useMutation, useQueryClient } from '@tanstack/react-query';

type UseRemoveRdEquipmentParams = {
  proposalId: string;
};

/**
 * Remove um item de equipamento da proposta (Step 2 — fluxo individual).
 * Sucesso refetcha `['rd-proposal', proposalId]` — o card some da lista
 * assim que a proposta volta atualizada do backend.
 */
export function useRemoveRdEquipment({
  proposalId,
}: UseRemoveRdEquipmentParams) {
  const queryClient = useQueryClient();

  return useMutation<RdProposal, Error, string>({
    mutationKey: ['quotes', 'rd-equipamentos', 'remove-equipment', proposalId],
    mutationFn: async (itemId: string) => {
      const response = await rdEquipamentosService.removeEquipment(
        proposalId,
        itemId
      );
      if (!response.success || !response.data) {
        throw new Error(response.error || 'Erro ao remover equipamento');
      }

      return response.data;
    },
    onSuccess: async () => {
      await queryClient.refetchQueries({
        queryKey: ['rd-proposal', proposalId],
      });
    },
  });
}
